import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { CustomTaskDialog } from '@roc/feature-general-tasks';
import { StandardDialog } from '@roc/ui';
import { useUserStore } from '@roc/feature-app-core';
import { LoanPricingTab } from '@roc/feature-loan-details';
import { useLoanStore } from '@roc/feature-loans';
import { useParams } from 'react-router-dom';
import { CircularProgress } from '@material-ui/core';

export interface PricingTermLoanDialogProps {
  open: boolean;
  onClose: () => void;
  document: any;
}

export const PricingTermLoanDialog = observer((props: PricingTermLoanDialogProps) => {
  const { open, onClose, document } = props;
  const taskId = document?.taskId;
  const { loanStore } = useLoanStore();
  const { userStore } = useUserStore();
  const { loanId } = useParams<{ loanId: string }>();
  const [isLoading, setIsLoading] = useState(false);
  const numericLoanId = Number(loanId);

  const fetchLoanDetails = async () => {
    if (!numericLoanId) return;
    setIsLoading(true);
    await loanStore.fetchLoanDetails(numericLoanId, () => {
      setIsLoading(false);
    });
  };

  useEffect(() => {
    userStore.getUserInfoAndEntitlements();
  }, [userStore]);

  useEffect(() => {
    if (!numericLoanId) return;
    if (loanStore?.loanDetails?.loanId !== numericLoanId) {
      fetchLoanDetails();
    }
  }, [numericLoanId]);

  return isLoading ? (
    <CircularProgress variant="indeterminate" />
  ) : (
    <>
      {taskId ? (
        <CustomTaskDialog
          open={open}
          title="Pricing"
          handleClose={onClose}
          dialogContent={
            <LoanPricingTab source={userStore.isNportalUser ? 'nportal' : 'cportal'} />
          }
          taskId={taskId}
        />
      ) : (
        <StandardDialog
          open={open}
          title="Pricing"
          maxWidth="md"
          handleClose={onClose}
          dialogContent={
            <LoanPricingTab source={userStore.isNportalUser ? 'nportal' : 'cportal'} />
          }
        />
      )}
    </>
  );
});
